import { config, material, project } from '@alilc/lowcode-engine';
import { Message } from '@alifd/next';
import initialSchema from '../public/schema.json'
let projectSchema = '';
export const preview = () => {
  saveSchema();
  setTimeout(() => {  
    window.open('./preview.html');
  }, 500);
};

export const saveSchema = () => {
  const packageName = config.get('packageName')

  window.localStorage.setItem(
    packageName + 'Schema',
    JSON.stringify(project.exportSchema())
  );
  const packages = material.getAssets()?.packages;
  window.localStorage.setItem(
    packageName + 'Packages',
    JSON.stringify(packages)
  );
  Message.success('成功保存到本地');
};

export const resetSchema = async () => {
  const packageName = config.get('packageName')

  const projectSchema = JSON.parse(
    window.localStorage.getItem(packageName + 'Schema') || `{
      "componentName": "Page"
    }`
  );
  projectSchema.componentsTree = [{
    componentName: 'Page'
  }];

  window.localStorage.setItem(
    packageName + 'Schema',
    JSON.stringify(projectSchema)
  );
  project.getCurrentDocument()?.importSchema({
    componentName: 'Page',
    fileName: 'sample',
  });
  project.simulator.rerender();
  Message.success('成功重置页面');
}

export const getPackages = () => {
  // const packageName = config.get('packageName')

  return JSON.parse(window.localStorage.getItem(projectSchema + 'Packages') || '[]');
}

export const getPageSchemaFromLocalStorage = () => {
  const packageName = config.get('packageName')

  const schema = JSON.parse(
    window.localStorage.getItem(projectSchema + 'Schema') || '{}'
  );

  return schema;
}

export const getPageSchema = async () => {
  const packageName = config.get('packageName')

  const schema = JSON.parse(
    window.localStorage.getItem(packageName + 'Schema') || '{}'
  );

  const pageSchema = schema?.componentsTree?.[0];

  if (pageSchema) {
    return pageSchema;
  }
  return initialSchema;
};
